export default __webpack_public_path__ + "static/media/Vector-3.e8fa3b93.svg";